@import ../../styles/helpers

.container
    width: fit-content
    margin: auto

.top
    +m
        margin-bottom: 32px
        padding-bottom: 16px
        border-bottom: 1px solid $neutrals6
        +dark
            border-color: $neutrals3

.loaderContainer
    width: 100%
    display: flex
    justify-content: center

.title
    margin-bottom: 16px

.info
    color: $neutrals4
    strong
        font-weight: 500
        color: $neutrals2
        +dark
            color: $neutrals8

.row
    display: flex
    +d
        display: block
        margin: 0

.col
    margin: 0 16px
    +d
        width: 100%
        margin: 0
    &:not(:last-child)
        +d
            margin-bottom: 64px
        +m
            margin-bottom: 32px
            padding-bottom: 32px
            border-bottom: 1px solid $neutrals6
            +dark
                border-color: $neutrals3

.user
    display: flex
    +d
        max-width: 416px

.avatar
    flex-shrink: 0
    width: 80px
    height: 80px
    margin-right: 32px
    position: relative
    +d
        width: 64px
        height: 64px
        margin-right: 16px
        margin-bottom: $external_margin
    img
        width: 100%
        height: 100%
        border-radius: 50%
        object-fit: cover
    
.details
    flex-grow: 1

.stage
    margin-bottom: 8px
    +body-bold-2

.text
    margin-bottom: 16px
    +caption-2
    color: $neutrals4

.file
    display: inline-block
    position: relative
    overflow: hidden

.load
    position: absolute
    top: 0
    left: 0
    opacity: 0
    width: 100%
    height: 100%
    cursor: pointer
    
.list
    margin-bottom: 40px
    +m
        display: block
        margin: 0 0 32px

.item
    +m
        width: 100%
        margin: 0
    & > .button
        margin-top: 32px
    &:not(:last-child)
        margin-bottom: 40px
        +m
            margin-bottom: 32px

.category
    margin-bottom: 32px
    +body-bold-2

.fieldset 
    & > .field
        &:not(:last-child)
            margin-bottom: 32px

.box
    position: relative
    .button
        position: absolute
        right: 12px
        bottom: 8px
        height: 32px
        padding: 0 10px

.note
    color: $neutrals4

.btns
    display: flex
    margin-top: 20px
    margin-bottom: 40px
    padding-bottom: 40px
    border-bottom: 1px solid $neutrals6
    +m
        display: block
        text-align: center
    +dark
        border-color: $neutrals3
    .button
        +m
            width: 100%
        &:not(:last-child)
            margin-right: 32px
            +m
                margin: 0 0 32px

.input_button
    position: relative

.clear
    display: inline-flex
    align-items: center
    +button-1
    color: $neutrals4
    transition: color .2s
    svg
        margin-right: 8px
        fill: $neutrals4
        transition: fill .2s
    &:hover
        color: $blue
        svg
            fill: $blue

.modal_container
    max-width: 800px
    border-radius: 16px
    background-color: $neutrals2
    padding: 20px
    padding-bottom: 40px
    position: relative
    padding-top: 80px
    padding-bottom: 80px

.photo_edit_container
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column

.form__title
    font-size: 40px
    font-weight: 500px !important
    text-align: center

.profile_image
    width: 200px
    height: 200px
    overflow: hidden
    margin-top: 30px
    margin-bottom: 30px
    border-radius: 100%
    img
        object-fit: cover
        max-width: inherit
        max-height: inherit
        height: inherit
        width: inherit

.form_divisor
    display: flex
    justify-content: center
    align-items: center
    gap: 40px